import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Avatar,
  Link,
} from '@heroui/react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

interface EndSurveyCardMatProps {
  endSurveyCompleted: boolean;
  endSurveyId: number;
}

export function EndSurveyCardMat({
  endSurveyCompleted,
  endSurveyId,
}: EndSurveyCardMatProps) {
  const { t } = useTranslation('home');

  if (endSurveyCompleted) return null;

  return (
    <Card className="bg-primary-100" radius="sm" shadow="sm">
      <CardHeader className="flex gap-4 pb-0">
        <Avatar
          color="primary"
          icon={<Icon icon="mdi:hand-heart" className="text-2xl" />}
          size="md"
        />
        <div className="flex flex-col">
          <h2 className="font-semibold">{t('endsurveycardmat.title')}</h2>
        </div>
      </CardHeader>
      <CardBody>
        <p>{t('endsurveycardmat.description')}</p>
        <Button
          as={Link}
          href={`/tracker/${endSurveyId}`}
          className="mt-4 w-1/4 place-self-end"
          color="primary"
        >
          {t('endsurveycardmat.button')}
        </Button>
      </CardBody>
    </Card>
  );
}
